export const INIT_SDK = 'INIT_SDK'
export const APPLY_LIST = 'APPLY_LIST' //监听申请列表
export const SESSION_LIST = 'SESSION_LIST' //监听会话用户列表
export const FRIEND_LIST = 'FRIEND_LIST'   //通讯录列表
export const CHAT_LIST = 'CHAT_LIST'   //聊天信息列表
export const SEND_CHAT = 'SEND_CHAT'   //发送文本聊天
export const SEND_APPLY = 'SEND_APPLY' //发送申请添加好友
export const SEND_AGREE = 'SEND_AGREE' //同意好友申请
export const SEND_REJECT = 'SEND_REJECT' //拒绝好友申请
export const SEND_ADD_HEALTH_DATA = 'SEND_ADD_HEALTH_DATA'  //添加健康数据
export const INIT_NETCALL = 'INIT_NETCALL'
export const INIT_NETCON = 'INIT_NETCON'//监听网络连接



// WEBPACK FOOTER //
// ./src/store/mutation-type.js